import React from 'react';

import { Styles } from './styles/admission';
import { BreadcrumbBoxDefault } from '../../components/common/default/BreadcrumbDefault';
import HeaderTwoDefault from '../../components/default/HeaderTwoDefault';
import FooterTwoDefault from '../../components/default/FooterTwoDefault';

const AdmissionDefault = () => {
    const admissionSteps = [
        {
            id: 1,
            title: "Online Application",
            steps: [
                "Fill out the online application form completely",
                "Fill required details (birth certificate, previous school records).",
                
            ]
        }
    ];

 

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper admission-process-page">

                {/* Header 2 */}
                <HeaderTwoDefault />

                {/* Breadcrumb */}
                <BreadcrumbBoxDefault title="Admission Process" />

                {/* Admission Process Area */}
                <section className="admission-process-area">
                    <Styles>
                        <div className="admission-page">
                            <div className="process-area">
                                <div className="container">
                                    <div className="section-title">
                                        <h1>School Admission Process</h1>
                                        <p>Follow these steps to enroll your child in our institution</p>
                                    </div>

                                    {admissionSteps.map((section) => (
                                        <div key={section.id} className="process-section">
                                            <div className="section-header">
                                                <h3>Step {section.id}: {section.title}</h3>
                                            </div>
                                            <div className="process-list">
                                                <ul>
                                                    {section.steps.map((step, index) => (
                                                        <li key={index}>
                                                            <div className="step-number">{index + 1}</div>
                                                            <div className="step-content">{step}</div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    ))}


                                    <div className="admission-note">
                                        <h4>Apply Now:</h4>
                                        <p>Click the link to begin the online admission process:<span><a href="https://amalambikanew.dschoolapp.com/admission" target="_blank" rel="noopener noreferrer"> Apply Here</a></span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Styles>
                </section>

                {/* Footer 2 */}
                <FooterTwoDefault />

            </div>
        </Styles>
    );
};

export default AdmissionDefault;